"use strict";

module.exports = function ($templateContainer, data, templateName) {
	if (data.status == "maintenance") {
		data.isProcessingUpdate = true;
	} else if (data.status == "access_denied") {
		$templateContainer.html('<div class="alert alert-danger">У вас не хватает прав для выполнения этого действия.</div>');
		return;
	} else if (data.status != "ready") {
		$templateContainer.html('<div class="alert alert-danger">В работе сервиса произошла ошибка.</div>');
		return;
	}

	var source = $("[data-handlebars-template=" + templateName + "]").html(),
		template = Handlebars.compile(source);

	$templateContainer.html(template(data));
};